// extracted by mini-css-extract-plugin
export default {"modalOverlay":"kD-z","modalContent":"lD-z","header":"mD-z","close":"nD-z"};